<div class="top-section" *ngIf="isTopSection">
  <div
    *ngIf="!isSingleSelectView && !isSelectTopSection"
    class="ngx-datatable-top-section"
  >
    <div *ngFor="let control of searchControlSettings">
      <nb-select
        [id]="control.property"
        [selected]="
          filters[control.property] != null
            ? filters[control.property]
            : control.defaultValue != null
              ? control.defaultValue
              : ''
        "
        (selectedChange)="
          onFilterChange({ value: $event, id: control.property })
        "
      >
        <nb-option
          *ngFor="let option of control.options | keyvalue: keyvalueKeepOrder"
          [value]="option.key"
        >
          {{ option.value }}
        </nb-option>
      </nb-select>
    </div>
  </div>

  <div class="select-top-section" *ngIf="isSelectTopSection">
    <div class="filter-table">
      <div class="filter-row">
        <div *ngFor="let control of searchControlSettings" class="filter-cell">
          <nb-select
            [id]="control.property"
            [selected]="
              filters[control.property] != null
                ? filters[control.property]
                : control.defaultValue != null
                  ? control.defaultValue
                  : ''
            "
            (selectedChange)="
              onFilterChange({ value: $event, id: control.property })
            "
          >
            <nb-option
              *ngFor="
                let option of control.options | keyvalue: keyvalueKeepOrder
              "
              [value]="option.key"
            >
              {{ option.value }}
            </nb-option>
          </nb-select>
        </div>
      </div>
    </div>
  </div>

  <div
    class="ngx-datatable-search"
    fxFlex="0 0 170px"
    *ngIf="searchable"
    fxLayout="column"
    fxLayoutGap="5px"
  >
    <label class="label" for="search">Search</label>
    <input
      class="nbInput"
      nbInput
      type="text"
      placeholder="Search for..."
      [(ngModel)]="searchExpression"
      (keyup)="search($event)"
      id="search"
    />
  </div>
</div>

<div *ngIf="isSingleSelectView" class="filter-container">
  <div
    class="ngx-datatable-embedded-filter"
    *ngFor="let control of searchControlSettings"
  >
    <nb-select
      [id]="control.property"
      [selected]="
        filters[control.property] != null
          ? filters[control.property]
          : control.defaultValue != null
            ? control.defaultValue
            : ''
      "
      (selectedChange)="onFilterChange({ value: $event, id: control.property })"
    >
      <nb-option
        *ngFor="let option of control.options | keyvalue"
        [value]="option.key"
      >
        {{ option.value }}
      </nb-option>
    </nb-select>
  </div>
</div>

<ngx-datatable
  *ngIf="!useSelectHeader"
  class="material"
  [rows]="rows"
  [columns]="columns"
  [columnMode]="columnMode"
  [headerHeight]="40"
  [footerHeight]="50"
  rowHeight="auto"
  [limit]="20"
  [style.min-height]="minHeight"
  style="height: 100%"
>
  <ngx-datatable-column
    *ngFor="let column of columns"
    [name]="column.name!"
    [prop]="column.prop!"
    [width]="column.width!"
    [minWidth]="column.minWidth!"
    [canAutoResize]="column.canAutoResize!"
    [sortable]="column.sortable!"
    [cellClass]="column.cellClass ?? ''"
    [resizeable]="false"
    class="custom-table"
  >
    <ng-template
      let-row="row"
      let-value="value"
      let-cellIndex="cellIndex"
      let-rowIndex="rowIndex"
      ngx-datatable-cell-template
    >
      <span *ngIf="column.type && column.type === 'TIME'">
        {{ value | convertMillisToMinutesSeconds }}
      </span>
      <span *ngIf="value && column.type && column.type === 'IMAGE'">
        <img [src]="value" class="row-image" />
      </span>
      <span *ngIf="!column.type">
        {{ value }}
      </span>
      <ng-container *ngIf="column.type && column.type === 'ARRAY'">
        <div *ngFor="let item of value | keyvalue">
          <div *ngIf="item.key === 'picture'">
            <img [src]="item.value" class="row-image" />
          </div>
          <div *ngIf="item.key !== 'picture'" class="array-info">
            {{ item.value }}
          </div>
        </div>
      </ng-container>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-footer *ngIf="isCustomFooter" class="datatable-footer">
    <ng-template
      ngx-datatable-footer-template
      let-rowCount="rowCount"
      let-pageSize="pageSize"
      let-selectedCount="selectedCount"
      let-curPage="curPage"
      let-offset="offset"
      let-isVisible="isVisible"
    >
      <div class="customFooter-container">
        <div class="customFooter">
          <datatable-pager
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [pagerNextIcon]="'datatable-icon-skip'"
            [page]="curPage"
            [size]="pageSize"
            [count]="rowCount"
            [hidden]="!(rowCount / pageSize > 1)"
            (change)="table?.onFooterPage($event)"
          >
          </datatable-pager>
        </div>
      </div>
    </ng-template>
  </ngx-datatable-footer>
</ngx-datatable>

<ngx-datatable
  *ngIf="useSelectHeader"
  class="material responsive-view"
  [rows]="rows"
  [columns]="columns"
  [columnMode]="columnMode"
  [headerHeight]="60"
  [footerHeight]="50"
  rowHeight="auto"
  [limit]="20"
  [style.min-height]="minHeight"
  style="height: 100%"
>
  <ngx-datatable-column
    *ngFor="let column of columns"
    [name]="column.name!"
    [prop]="column.prop!"
    [width]="column.width!"
    [minWidth]="column.minWidth!"
    [canAutoResize]="column.canAutoResize!"
    [sortable]="column.sortable!"
    [resizeable]="false"
    class="custom-table"
  >
    <ng-template ngx-datatable-header-template>
      <div *ngIf="getControlForColumn(column.prop) as control">
        <nb-select
          [id]="column.prop"
          [selected]="
            filters[control.property] != null
              ? filters[control.property]
              : control.defaultValue != null
                ? control.defaultValue
                : ''
          "
          (selectedChange)="
            onFilterChange({
              value: $event,
              id: column.prop,
            })
          "
        >
          <nb-option
            *ngFor="let option of control.options | keyvalue: keyvalueKeepOrder"
            [value]="option.key"
          >
            {{ option.value }}
          </nb-option>
        </nb-select>
      </div>
    </ng-template>

    <ng-template
      let-row="row"
      let-value="value"
      let-cellIndex="cellIndex"
      let-rowIndex="rowIndex"
      ngx-datatable-cell-template
    >
      <span *ngIf="column.type && column.type === 'TIME'">
        {{ value | convertMillisToMinutesSeconds }}
      </span>
      <span *ngIf="value && column.type && column.type === 'IMAGE'">
        <img [src]="value" class="row-image" />
      </span>
      <span *ngIf="!column.type">
        {{ value }}
      </span>
      <ng-container *ngIf="column.type && column.type === 'ARRAY'">
        <div *ngFor="let item of value | keyvalue">
          <div *ngIf="item.key === 'picture'">
            <img [src]="item.value" class="row-image" />
          </div>
          <div *ngIf="item.key !== 'picture'" class="array-info">
            {{ item.value }}
          </div>
        </div>
      </ng-container>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-footer *ngIf="isCustomFooter" class="datatable-footer">
    <ng-template
      ngx-datatable-footer-template
      let-rowCount="rowCount"
      let-pageSize="pageSize"
      let-selectedCount="selectedCount"
      let-curPage="curPage"
      let-offset="offset"
      let-isVisible="isVisible"
    >
      <div class="customFooter-container">
        <div class="customFooter">
          <datatable-pager
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [pagerNextIcon]="'datatable-icon-skip'"
            [page]="curPage"
            [size]="pageSize"
            [count]="rowCount"
            [hidden]="!(rowCount / pageSize > 1)"
            (change)="table?.onFooterPage($event)"
          >
          </datatable-pager>
        </div>
      </div>
    </ng-template>
  </ngx-datatable-footer>
</ngx-datatable>
